import styled from 'styled-components';

export default styled.div`
  z-index: 1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  background-color: #222;

  &:after {
    content: "";
    position: absolute;
    top: -1rem;
    right: -1rem;
    bottom: -1rem;
    left: -1rem;
    width: calc(100% + 2rem);
    background: url(${({ src }) => src}) center no-repeat;
    background-size: cover;
    filter: blur(.375rem);
    opacity: .05;
  }
`;
